import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import * as Sentry from '@sentry/browser';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import configureStore from './config/store';
import './index.css';
import { isWebinar, isSpacee, isFVlite} from './lib/lib'
import config from './config/config'

if (window.location.hostname !== "localhost"){
  Sentry.init({
    dsn: config.SENTRY
  });
  Sentry.configureScope((scope) => {
    scope.setTag("gitHash", config.GIT_HASH);
    scope.setTag("gitBranch", config.GIT_BRANCH);
  });
}
(function() {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href =  isWebinar() ? window.location.origin + '/img/faviconWebinar.ico' :  (  isSpacee() ?  window.location.origin + '/img/faviconSpacee.ico' : isFVlite() ? window.location.origin + '/img/faviconFVlite.ico' : window.location.origin + '/img/faviconDD.ico')
  document.getElementsByTagName('head')[0].appendChild(link);
  document.title = isWebinar() ? "Webinar" : isFVlite() ? "FVlite" :  ( isSpacee() ? "spacee " + window.location.pathname.replace(/\//g, '') : "DD")
})();

// using MuiThemeProvider to inject the theme into our application context
const App = () => (
  <MuiThemeProvider>
    <Routes />
  </MuiThemeProvider>
);

/* We use a special React Redux component called <Provider> to magically make
  the store available to all container components in the application without
  passing it explicitly. */
ReactDOM.render(
  <Provider store={configureStore}>
    <App />
  </Provider>,
  document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js